module.exports = __webpack_public_path__ + "img/deskshelf18.983d3649.jpg";